import { Chip } from "../ui";
import { telasDoPerfil, type MatrizDeTelas } from "../../nucleo/telas";

/**
 * O que o perfil contém, tela a tela: quem atribui precisa saber o que está dando. Aparece junto
 * da escolha de perfil, no convite e na troca.
 */
export function TelasDoPerfil({
  matriz,
  perfil,
}: {
  matriz: MatrizDeTelas | undefined;
  perfil: string;
}) {
  const telas = telasDoPerfil(matriz, perfil);
  if (!telas) return null;
  return (
    <div className="mb-3" data-testid="telas-do-perfil" aria-live="polite">
      <p className="campo__ajuda">
        {telas.contem.length === 0
          ? "Este perfil não dá acesso a nenhuma tela."
          : "Este perfil dá acesso a:"}
      </p>
      <ul className="flex flex-wrap gap-1">
        {telas.contem.map((tela) => (
          <li key={tela.chave}>
            <Chip estado={tela.sensivel ? "atencao" : "ok"} semPonto>
              {tela.rotulo}
            </Chip>
          </li>
        ))}
        {telas.nao.map((tela) => (
          <li key={tela.chave} data-testid={`sem-${tela.chave}`}>
            <Chip estado="neutro" semPonto>
              sem {tela.rotulo}
            </Chip>
          </li>
        ))}
      </ul>
    </div>
  );
}
